export default __webpack_public_path__ + "static/banner-how-to-manage-your-money-digitally-cd684b8a44c95444e85b698c0f12e7fd.jpg";